import GameParameterInterface from '@/models/game/parameters/interface'

export default class EmptyParameter implements GameParameterInterface {

  createSetOption(): object {
    return {}
  }

  get guideUrl(): string {
    return ''
  }
}
